!function (a) {
  var i = {
    pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\]\\]|\\.)*\]|[^\]\\]|\\.)*\]/m,
    lookbehind: !0,
    inside: {
      quoted: {
        pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
        inside: {
          punctuation: /^[$`]|[$`]$/
        }
      },
      interpreted: {
        pattern: /'(?:[^'\\]|\\.)*'/,
        inside: {
          punctuation: /^'|'$/
        }
      },
      string: /"(?:[^"\\]|\\.)*"/,
      variable: /\w+(?==)/,
      punctuation: /^\[|\]$|,/,
      operator: /=/,
      "attr-value": /(?!^\s+$).+/
    }
  };
  a.languages.asciidoc = {
    "comment-block": {
      pattern: /^(\/{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1/m,
      alias: "comment"
    },
    table: {
      pattern: /^\|={3,}(?:(?:\r?\n|\r).*)*?(?:\r?\n|\r)\|={3,}$/m,
      inside: {
        specifiers: {
          pattern: /(?!\|)(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*])?(?:[<^>](?:\.[<^>])?|\.[<^>])?[a-z]*)(?=\|)/,
          alias: "attr-value"
        },
        punctuation: {
          pattern: /(^|[^\\])[|!]=*/,
          lookbehind: !0
        }
      }
    },
    "passthrough-block": {
      pattern: /^(\+{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
      inside: {
        punctuation: /^\++|\++$/
      }
    },
    "literal-block": {
      pattern: /^(-{4,}|\.{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
      inside: {
        punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
      }
    },
    "other-block": {
      pattern: /^(--|\*{4,}|_{4,}|={4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
      inside: {
        punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
      }
    },
    "list-punctuation": {
      pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
      lookbehind: !0,
      alias: "punctuation"
    },
    "list-label": {
      pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
      lookbehind: !0,
      alias: "symbol"
    },
    "indented-block": {
      pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
      lookbehind: !0
    },
    comment: /^\/\/.*/m,
    title: {
      pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} +.+|^\.(?![\s.]).*/m,
      alias: "important",
      inside: {
        punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
      }
    },
    "attribute-entry": {
      pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
      alias: "tag"
    },
    attributes: i,
    hr: {
      pattern: /^'{3,}$/m,
      alias: "punctuation"
    },
    "page-break": {
      pattern: /^<{3,}$/m,
      alias: "punctuation"
    },
    admonition: {
      pattern: /^(?:TIP|NOTE|IMPORTANT|WARNING|CAUTION):/m,
      alias: "keyword"
    },
    callout: [{
      pattern: /(^[ \t]*)<?\d*>/m,
      lookbehind: !0,
      alias: "symbol"
    }, {
      pattern: /<\d+>/,
      alias: "symbol"
    }],
    macro: {
      pattern: /\b[a-z\d][a-z\d-]*::?(?:(?:\S+)??\[(?:[^\]\\"]|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
      inside: {
        "function": /^[a-z\d-]+(?=:)/,
        punctuation: /^::?/,
        attributes: {
          pattern: /(?:\[(?:[^\]\\"]|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
          inside: i.inside
        }
      }
    },
    inline: {
      pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"]|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?: ['`]|.)+?(?:(?:\r?\n|\r)(?: ['`]|.)+?)*['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"]|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
      lookbehind: !0,
      inside: {
        attributes: i,
        url: {
          pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
          inside: {
            punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
          }
        },
        "attribute-ref": {
          pattern: /^\{.+\}$/,
          inside: {
            variable: {
              pattern: /(^\{)[a-z\d,+_-]+/,
              lookbehind: !0
            },
            operator: /^[=?!#%@$]|!(?=[:}])/,
            punctuation: /^\{|\}$|::?/
          }
        },
        italic: {
          pattern: /^(['_])[\s\S]+\1$/,
          inside: {
            punctuation: /^(?:''?|__?)|(?:''?|__?)$/
          }
        },
        bold: {
          pattern: /^\*[\s\S]+\*$/,
          inside: {
            punctuation: /^\*\*?|\*\*?$/
          }
        },
        punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
      }
    },
    replacement: {
      pattern: /\((?:C|TM|R)\)/,
      alias: "builtin"
    },
    entity: /&#?[\da-z]{1,8};/i,
    "line-continuation": {
      pattern: /(^| )\+$/m,
      lookbehind: !0,
      alias: "punctuation"
    }
  }, i.inside.interpreted.inside.rest = {
    macro: a.languages.asciidoc.macro,
    inline: a.languages.asciidoc.inline,
    replacement: a.languages.asciidoc.replacement,
    entity: a.languages.asciidoc.entity
  }, a.languages.asciidoc["passthrough-block"].inside.rest = {
    macro: a.languages.asciidoc.macro
  }, a.languages.asciidoc["literal-block"].inside.rest = {
    callout: a.languages.asciidoc.callout
  }, a.languages.asciidoc.table.inside.rest = {
    "comment-block": a.languages.asciidoc["comment-block"],
    "passthrough-block": a.languages.asciidoc["passthrough-block"],
    "literal-block": a.languages.asciidoc["literal-block"],
    "other-block": a.languages.asciidoc["other-block"],
    "list-punctuation": a.languages.asciidoc["list-punctuation"],
    "indented-block": a.languages.asciidoc["indented-block"],
    comment: a.languages.asciidoc.comment,
    title: a.languages.asciidoc.title,
    "attribute-entry": a.languages.asciidoc["attribute-entry"],
    attributes: a.languages.asciidoc.attributes,
    hr: a.languages.asciidoc.hr,
    "page-break": a.languages.asciidoc["page-break"],
    admonition: a.languages.asciidoc.admonition,
    "list-label": a.languages.asciidoc["list-label"],
    callout: a.languages.asciidoc.callout,
    macro: a.languages.asciidoc.macro,
    inline: a.languages.asciidoc.inline,
    replacement: a.languages.asciidoc.replacement,
    entity: a.languages.asciidoc.entity,
    "line-continuation": a.languages.asciidoc["line-continuation"]
  }, a.languages.asciidoc["other-block"].inside.rest = {
    table: a.languages.asciidoc.table,
    "list-punctuation": a.languages.asciidoc["list-punctuation"],
    "indented-block": a.languages.asciidoc["indented-block"],
    comment: a.languages.asciidoc.comment,
    "attribute-entry": a.languages.asciidoc["attribute-entry"],
    attributes: a.languages.asciidoc.attributes,
    hr: a.languages.asciidoc.hr,
    "page-break": a.languages.asciidoc["page-break"],
    admonition: a.languages.asciidoc.admonition,
    "list-label": a.languages.asciidoc["list-label"],
    macro: a.languages.asciidoc.macro,
    inline: a.languages.asciidoc.inline,
    replacement: a.languages.asciidoc.replacement,
    entity: a.languages.asciidoc.entity,
    "line-continuation": a.languages.asciidoc["line-continuation"]
  }, a.languages.asciidoc.title.inside.rest = {
    macro: a.languages.asciidoc.macro,
    inline: a.languages.asciidoc.inline,
    replacement: a.languages.asciidoc.replacement,
    entity: a.languages.asciidoc.entity
  }, a.hooks.add("wrap", function (a) {
    "entity" === a.type && (a.attributes.title = a.content.replace(/&amp;/, "&"));
  });
}(Prism);